import { DesktopSidebar } from './components/DesktopSidebar';
import { DesktopSidebarWithSnowflakeWrapper } from './styled';
import { FadingSnowflake } from './components/FadingSnowflake';
import { Box } from '@simplywallst/ui-core';

interface DesktopSidebarWithSnowflakeProps {
  selected: string;
  handleClick?: (section: string) => void;
  keepSnowflakePinned?: boolean;
}

export const DesktopSidebarWithSnowflake = ({
  selected,
  handleClick,
  keepSnowflakePinned,
}: DesktopSidebarWithSnowflakeProps) => {
  return (
    <DesktopSidebarWithSnowflakeWrapper data-cy-id="desktop-sidebar-snowflake-wrapper">
      <FadingSnowflake
        onClick={handleClick}
        keepSnowflakePinned={keepSnowflakePinned}
      />
      <Box>
        <DesktopSidebar selected={selected} handleClick={handleClick} />
      </Box>
    </DesktopSidebarWithSnowflakeWrapper>
  );
};
